export default "__VITE_ASSET__C5A6esu3__"